import React from 'react';
import { Link } from "react-router-dom";
import Auth from "../../services/Auth.service";
import { useTranslation } from "react-i18next";

export default function OrderForecastOrderNavigation() {

    const { t } = useTranslation();

    return (
        <div>
            {Auth.isUserLoged ? <div>
                <br />
                <div className="container-fluid">
                    <div className="col-12 col-lg-11 mx-auto">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/OrderForecastOrderNavigation/'}>{t("Global_Label_Text_Order_Forecast")}</Link></li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
                <div>
                    <h1>holaaa soy lean x2</h1>
                </div>
                <br />
            </div > : ""}
        </div>
    );

}
